import { FC, useState } from "react";
import { ViewProps } from "../types";

export type WithModalProps = {
  handleCircleClick: (details: any) => void;
  handleCloseModal: () => void;
  modal: string;
};

export const withModal = (View: FC<WithModalProps>) => (props: ViewProps) => {
  const [modal, setModal] = useState("");

  // Handle circle click
  const handleCircleClick = (details: any) => {
    props?.setDetails?.({
      title: details?.title,
      description: details?.description,
      image: details?.image,
    });

    setModal("showDetails");
  };

  const handleCloseModal = () => {
    setModal("");
    props?.setDetails?.(null);
  };

  return (
    <View
      {...props}
      handleCircleClick={handleCircleClick}
      handleCloseModal={handleCloseModal}
      modal={modal}
    />
  );
};
